module.exports = __webpack_public_path__ + "img/電気回路_1_8_3.fd564a52.png";